module.exports = __webpack_public_path__ + "assets/img/20_52_big.0b475ebc.jpg";